import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://fantasy-jq2t.onrender.com";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: "https://fantasy-jq2t.onrender.com/api",
  withCredentials: true,
});

export function extractPlayers(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.players)) return data.players;
  return [];
}

export const POSITION_STYLES = {
  // NFL
  QB:  "bg-red-500/15 text-red-300 border-red-500/40",
  RB:  "bg-blue-500/15 text-blue-300 border-blue-500/40",
  WR:  "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  TE:  "bg-amber-500/15 text-amber-300 border-amber-500/40",
  K:   "bg-pink-500/15 text-pink-300 border-pink-500/40",
  DEF: "bg-slate-500/15 text-slate-300 border-slate-500/40",
  // NBA
  PG:  "bg-sky-500/15 text-sky-300 border-sky-500/40",
  SG:  "bg-violet-500/15 text-violet-300 border-violet-500/40",
  SF:  "bg-teal-500/15 text-teal-300 border-teal-500/40",
  PF:  "bg-orange-500/15 text-orange-300 border-orange-500/40",
  C:   "bg-rose-500/15 text-rose-300 border-rose-500/40",
  // MLB batters
  "1B": "bg-blue-500/15 text-blue-300 border-blue-500/40",
  "2B": "bg-cyan-500/15 text-cyan-300 border-cyan-500/40",
  "3B": "bg-amber-500/15 text-amber-300 border-amber-500/40",
  SS:   "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  OF:   "bg-green-500/15 text-green-300 border-green-500/40",
  DH:   "bg-purple-500/15 text-purple-300 border-purple-500/40",
  // MLB pitchers
  SP:   "bg-red-500/15 text-red-300 border-red-500/40",
  RP:   "bg-pink-500/15 text-pink-300 border-pink-500/40",
};

export const TAG_STYLES = {
  elite: "bg-emerald-500 text-slate-950 border-emerald-500",
  breakout: "bg-emerald-500/20 text-emerald-300 border-emerald-500/50",
  sleeper: "bg-blue-500/20 text-blue-300 border-blue-500/50",
  risk: "bg-red-500/20 text-red-300 border-red-500/50",
};

export const TAG_LABELS = {
  elite: "ELITE",
  breakout: "BREAKOUT",
  sleeper: "SLEEPER",
  risk: "BUST RISK",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
